import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/X";
import { colors } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import { CustomFormInput } from "../../Components/Common/CreatePagesComponents";
import { Email, Password } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin, } from "../../redux/slices/adminSlice";

const AdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { token, loading, error } = useSelector((state) => state.admin);

  const handleLogin = () => {
    if(!email || !password) {
      alert("Please fill in all fields");
      return;
    }
    dispatch(adminLogin({ email, password }));
  };

  // Redirect if already logged in
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
        textAlign: "center",
        height: "100%",
        bgcolor: "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img
          src={require("../../assets/images/login-handpik-logo.png")}
          alt="Logo"
          style={{ width: "221px", height: "184px" }}
        />
      </div>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 500,
          fontFamily: "Poppins-Bold",
          fontSize: "20px",
          color: colors.textColor,
          textAlign: "left",
          mt: 4,
        }}
      >
        Login to your Admin Account
      </Typography>

      {/* Error message */}
      {error && <Typography sx={{ color: "red", mb: 2, textAlign: "left" }}>{error}</Typography>}

      {/* Email & Password */}
      <CustomFormInput value={email} setValue={setEmail} placeholder="Email*" Icon={Email} />
      <CustomFormInput value={password} setValue={setPassword} placeholder="Password*" Icon={Password} />

      {/* Sign In Button */}
      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: "#3C3C3C",
          color: "white",
          mt: 2,
          mb: 1,
          fontSize: "15px",
          borderRadius: "10px",
        }}
        onClick={handleLogin}
        disabled={loading}
      >
        {loading ? "Signing In..." : "Sign In"}
      </Button>
    </Box>
  );
};

export default AdminLogin;
